import React from 'react';
import RevealMixin from './../reveal_mixin';
import CustomStylesMixin from './../custom_styles_mixin';

import createReactClass from 'create-react-class';
export default createReactClass({
  displayName: '404',

  mixins: [CustomStylesMixin, RevealMixin],

  render: function() {
    return (
      <div className="content-container">
        <div className="head-line" style={this.secondary_text_color()}>
          404
        </div>
        <div className="subheader" style={this.primary_text_color()}>
          Oops, the page you're looking for does not exist.
        </div>
        <hr style={this.hrBackgroundColor()} />
        <div className="clearfix"></div>
        <div className="context" style={this.primary_text_color()}>
          <p>
            You may want to head back to the homepage.
            <br />
            If you think something is broken, report a problem.
          </p>
        </div>
        <div className="buttons-container">
          <a
            href={this.href(this.props.homepage_url)}
            style={this.borderButton()}
            target="_blank"
          >
            Go to homepage
          </a>
          <a
            href={this.support_email_address()}
            style={this.borderButton()}
            target="_blank"
          >
            Report a problem
          </a>
        </div>
      </div>
    );
  },
});
